import { gsap } from 'gsap';

export function initCardCollapsible(card) {
  if (!card) return;

  card.addEventListener('click', () => {
    card.classList.toggle('is-active');
  });
}

export function initAllCollapsibleCards() {
  const blocks = document.querySelectorAll(
    '.js-block-card-collapsible, .js-block-icon-card-collapsible',
  );
  blocks.forEach((block) => initCardCollapsible(block));
}
